<template>
  <header class="bg-primary text-white shadow-md fixed top-0 left-0 right-0 z-50 transition-custom">
    <div class="container mx-auto px-4 py-3 flex justify-between items-center">
      <div class="flex items-center space-x-2">
        <i class="fa fa-lock text-2xl"></i>
        <h1 class="text-xl md:text-2xl font-bold">密码管理器</h1>
      </div>
      <button @click="$emit('toggle-theme')" id="themeToggle" class="p-2 rounded-full hover:bg-primary/80 transition-custom">
        <i :class="darkMode ? 'fa fa-sun-o' : 'fa fa-moon-o'"></i>
      </button>
    </div>
  </header>
</template>

<script setup>

</script>

<style scoped>
/* 组件的样式 */
</style>